import * as React from "react";
import { createDevTools } from "redux-devtools";
import DockMonitor from "redux-devtools-dock-monitor";
import LogMonitor from "redux-devtools-log-monitor";
export var DevTools = createDevTools(React.createElement(DockMonitor, { toggleVisibilityKey: "ctrl-shift-h", changePositionKey: "ctrl-q", defaultIsVisible: false },
    React.createElement(LogMonitor, { theme: "tomorrow" })));



//////////////////
// WEBPACK FOOTER
// ./src/setup/DevTools.tsx
// module id = 745
// module chunks = 3